/** Prefer courtroom-specific copy when set; otherwise fall back to standard fields. */
export function resolveCourtroomCopy(
  primary?: string,
  fallback?: string,
): string | undefined {
  const trimmed = primary?.trim();
  return trimmed ? trimmed : fallback?.trim() || undefined;
}
